import { Create, TopToolbar } from "react-admin";
import { useState } from "react";
import BackButtonToolbar from "features/BackButtonToolbar";
import { MobilityVisitType } from "utils/constants";
import SaveForm from "./Partials/SaveForm";

const DOCUMENT_SOURCES = [
  "mobilityAgreementId",
  "cvId",
  "selectionProtocolId",
  "fundingAgreementId",
  "acceptanceLetterId",
  "certificateOfStayId",
  "certificateOfTeachingId",
  "businessTripReportId",
  "businessTripOrderId",
  "medicalInsuranceId",
  "travellerReportId",
];

const CreateErasmusOutgoingTeachers = () => {
  const [docIds, setDocIds] = useState({});
  const [travelDocumentIds, setTravelDocumentIds] = useState(null);

  const handleDocumentUpload = (source, id) => setDocIds(prev => ({ ...prev, [source]: id }));

  const handleSend = data => {
    const payload = {
      ...Object.fromEntries(Object.entries(data).filter(([key]) => !DOCUMENT_SOURCES.includes(key))),
      ...Object.fromEntries(DOCUMENT_SOURCES.map(key => [key, docIds[key] ?? null])),
      travelDocumentIds: travelDocumentIds ?? [],
    };

    // certificateOfTeachingId is only valid for Study/BIP — Traineeship would be rejected (422).
    if (payload.mobilityVisitType === MobilityVisitType.Internship) {
      payload.certificateOfTeachingId = null;
    }

    // bipName/bipNumber are BIP-specific. startDate/endDate are NOT — the BE accepts a period for
    // any visit type (only required for BIP), so leave the form's dates untouched here.
    if (payload.mobilityVisitType !== MobilityVisitType.BIP) {
      payload.bipName = null;
      payload.bipNumber = null;
    }

    return payload;
  };

  return (
    <Create
      transform={handleSend}
      title="Добави заминаващ служител"
      actions={
        <TopToolbar sx={{ paddingTop: "2rem", paddingRight: "2rem", gap: "1rem" }}>
          <BackButtonToolbar />
        </TopToolbar>
      }
    >
      <SaveForm
        onDocumentUpload={handleDocumentUpload}
        travelDocumentIds={travelDocumentIds}
        onTravelDocumentsChange={setTravelDocumentIds}
      />
    </Create>
  );
};

export default CreateErasmusOutgoingTeachers;
